import { Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { JOIN_STEPS } from "../../lib/ablemp-data";

export const Join = () => {
  return (
    <section
      id="associar"
      data-testid="join-section"
      className="relative bg-[#0A0F14] text-white py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 bg-grain-dark opacity-50 pointer-events-none" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-4 text-[11px] uppercase tracking-[0.3em] text-white/55">
          <span className="flag-rule" aria-hidden />
          <span>§ 05 — Associe-se à ABLEMP</span>
        </div>

        <div className="mt-10 grid grid-cols-12 gap-8 items-end">
          <h2
            data-testid="join-headline"
            className="col-span-12 lg:col-span-9 font-serif-display text-[36px] sm:text-[52px] lg:text-[80px] leading-[1.02] tracking-[-0.02em]"
          >
            Some sua voz à{" "}
            <span className="italic font-light text-[#FEDF00]">nossa</span>.
          </h2>
          <p className="col-span-12 lg:col-span-3 text-white/70 text-base leading-relaxed">
            A ABLEMP é uma associação civil, sem fins lucrativos. Pessoas
            físicas e empresas podem participar.
          </p>
        </div>

        <ol className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {JOIN_STEPS.map((s, i) => (
            <li
              key={s.n}
              data-testid={`join-step-${i}`}
              className="bg-[#0A0F14] hover:bg-[#131C24] transition-colors duration-500 p-8 md:p-10"
            >
              <div className="flex items-center justify-between">
                <span className="font-serif-display text-3xl text-[#009B3A]">
                  {s.n}
                </span>
                <span className="h-px w-10 bg-white/20" />
              </div>
              <h3 className="mt-8 font-serif-display text-2xl leading-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-sm text-white/65 leading-relaxed">
                {s.body}
              </p>
            </li>
          ))}
        </ol>

        <div className="mt-14 flex flex-wrap items-center gap-5">
          <Link
            data-testid="join-cta-signup"
            to="/cadastro"
            className="group inline-flex items-center gap-3 bg-[#FEDF00] text-[#0A0F14] px-7 py-4 text-[12px] uppercase tracking-[0.22em] font-bold hover:bg-white transition-colors duration-300"
          >
            Quero me associar
            <span className="h-px w-6 bg-[#0A0F14] group-hover:w-10 transition-all" />
          </Link>
          <a
            data-testid="join-cta-email"
            href="mailto:contato@ablemp.org.br?subject=Quero%20saber%20mais%20sobre%20a%20ABLEMP"
            className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-white/85 hover:text-[#FEDF00]"
          >
            <Mail size={14} strokeWidth={2} />
            Ou escreva para contato@ablemp.org.br
          </a>
        </div>
      </div>
    </section>
  );
};

export default Join;
